import { Link } from "react-router-dom";
import media from "../../../media";
import { getTimeAgo } from "../../../utils/Constants";

export default function NotificationPanel(props) {
  const { storeList, nCount } = props;

  return (
    <div id="kt_quick_panel" className="offcanvas offcanvas-right">
      <div className="notiHead">
        <h5 className="font-weight-bold">Notifications</h5>

        <div className="offcanvas-close position-relative">
          <span
            className="btn-icon"
            id="kt_quick_panel_close"
            onClick={() => {
              document
                .getElementById("kt_quick_panel")
                .classList.remove("offcanvas-on");
              document
                .querySelector("body")
                .classList.remove("overflow-hidden");
            }}
          >
            <i className="ki ki-close"></i>
          </span>
        </div>
      </div>
      <div className="notiCount">
        <div className="notiCountText">Recent ({storeList.length || 0})</div>
        {nCount !== 0 && (
          <div className="viewAll">
            <Link to="/notifications" className="notiViewAll seeAll">
              View All
            </Link>
          </div>
        )}
      </div>
      <div className="nottiBody">
        <ul>
          {storeList &&
            storeList.map((list, index) => {
              const timeAgo = getTimeAgo(list.createdAt);
              return (
                <li key={index}>
                  <img src={media.clock.svg} alt="noti icon" />
                  <Link
                    //to={`/notifications/${list?.id}`}
                    to="/notifications"
                    state={{ notificationId: list?.id }}
                    //to={`/notifications?notificationId=${list?.id}`}
                    className="d-flex items-center"
                  >
                    <div className="notiBodyText">
                      <p>{list.title}</p>
                      <small>{timeAgo}</small>
                    </div>
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}
